<template>
  <div class="tw-bg-gray-100 tw-p-2 tw-shadow tw-h-full">
    <div class="tw-flex tw-items-center tw-justify-between">
      <h4 class="tw-text-xl">System Variable</h4>
      <Input
        v-model="search"
        :placeholder="$t('search')"
        style="width: 200px"
        class="btn-sm"
      />
    </div>
    <ts-panel>
      <div id="container-table">
        <ts-table
          :columns="columns"
          :records="systemVariables"
          :loading="loading"
          mouse-type-on-row="pointer"
          @row-dblclick="onRowDblClick"
        >
          <template v-slot="{ record }">
            <td>{{ record.sv_name }}</td>
            <td>{{ record.display_name }}</td>
            <td>{{ record.data_type }}</td>
          </template>
        </ts-table>
      </div>
    </ts-panel>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { debounce } from "lodash";

export default {
  name: "system-variables",
  data() {
    return {
      columns: [
        { name: "Variable Name" },
        { name: "Description" },
        { name: "Data Type" },
      ],
      loading: false,
      search: "",
    };
  },
  computed: {
    ...mapState("payroll/payUserVariable", ["systemVariables"]),
  },
  methods: {
    ...mapActions("payroll/payUserVariable", ["getSystemVariables"]),
    onRowDblClick({ record }) {
      this.$emit("select-variable", record.sv_name);
    },
  },
  watch: {
    search: debounce(function (search) {
      this.loading = true;

      this.getSystemVariables({ search }).then(() => {
        this.loading = false;
      });
    }, 500),
  },
};
</script>

<style lang="css" scoped>
#container-table {
  height: 30vh;
  overflow-y: auto;
}
</style>
